module.exports = __webpack_public_path__ + "img/3.23b624b5.png";